import ax from "../APISetteings";

export const getQuotes = async () => {
  const response = await ax.get(`/`);
  return response.data;
};
